/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

/**
 * Used when calling for fees for a fee period that has already been called for.

When set to "actual"
-> the transaction date will be set to the actual date of this call

When set to "earliest_call_for_fee_charge_event"
-> the transaction date will be set to the effective date of the first call for the fee period (i.e. we treat later calls as "equalizing" the earlier call)

The effective event and effective sub event on the transactions are also set accordingly.
 */
export type CallForFeesTransactionDateEnum = typeof CallForFeesTransactionDateEnum[keyof typeof CallForFeesTransactionDateEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CallForFeesTransactionDateEnum = {
  actual: 'actual',
  earliest_call_for_fee_charge_event: 'earliest_call_for_fee_charge_event',
} as const;
